<template>
    <v-dialog :model-value="modelValue" class="no-show-dialog" max-width="300" persistent>
        <v-card>
            <v-card-text class="pa-10">
                <v-icon class="no-show-dialog__close" size="20" color="primary" @click="emit('close')"> mdi-close </v-icon>
                <p class="body-1 font-weight-bold text-center pb-3">Passasjerer uteblitt</p>
                <p class="pb-3">For å registrere passasjerer ikke møtt, velg alternativ under og klikk registrerer.</p>
                <v-radio-group v-model="noShowModel">
                    <v-radio v-for="option in noShowOptions" :key="option.value" :label="option.label" :value="option.value" class="mb-1" />
                </v-radio-group>
                <v-row align="center">
                    <v-col>
                        <v-btn color="primary" large block data-id="no-show-register-button" @click="registerNoShow"> Registrer </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { BookingNoShowType } from './BookingNoShowModels';

defineProps<{
    modelValue: boolean;
}>();

interface Emits {
    (e: 'close'): void;
    (e: 'register-noshow', value: BookingNoShowType): void;
}

const emit = defineEmits<Emits>();

const noShowOptions = [
    { label: 'Ingen reisende på kai', value: BookingNoShowType.NoTravellers },
    { label: 'For få reisende på kai', value: BookingNoShowType.TooFewTravellers }
];
const noShowModel = ref(BookingNoShowType.NoTravellers);

function registerNoShow() {
    emit('register-noshow', noShowModel.value);
}
</script>

<style lang="scss" scoped>
.no-show-dialog {
    &__close {
        position: absolute;
        top: 12px;
        right: 12px;
    }
}
</style>
